/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 21:16:05 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-03-03 14:46:01
 */
 <template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.brbRates.h1') }}</h1>
      <h2>
        {{ st('helpDocs.brbRates.h2Typical') }}
      </h2>
      <p>
        {{ st('helpDocs.brbRates.pIntro') }}
      </p>
      <artmisads-table
        bordered
        :data-source="tableData"
        :columns="tableColumns"
        :pagination="false"
      />
      <h2>{{ st('helpDocs.brbRates.h2Latest') }}</h2>
      <p>
        {{ st('helpDocs.brbRates.pLatest1') }}
        <a
          href="https://sellercentral.amazon.com/help/hub/reference/external/GL9HPJ34VBFP76HX?initialSessionID=apay%3D147-0673581-9434758&ld=NSGoogle"
          target="_blank"
          >{{ st('helpDocs.brbRates.aOfficial') }}</a
        >.
      </p>
      <p>
        {{ st('helpDocs.brbRates.pLatest2') }}
      </p>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()

const rowIds = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

const tableData = computed(() =>
  rowIds.map((i) => ({
    key: i,
    categories: st(`helpDocs.brbRates.r${i}c`),
    estimatedBonusRate: st(`helpDocs.brbRates.r${i}r`),
  }))
)

const tableColumns = computed(() => [
  {
    key: 'categories',
    dataIndex: 'categories',
    title: st('helpDocs.brbRates.colCategories'),
  },
  {
    width: '40%',
    key: 'estimatedBonusRate',
    dataIndex: 'estimatedBonusRate',
    title: st('helpDocs.brbRates.colRate'),
  },
])
</script>
